import * as C from '../common/constants';
import * as ROUTES from '../common/routes';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchData } from '../common/app/actions';
import CircularProgress from '@material-ui/core/CircularProgress';
import ImageStory from './ImageStory';
import {
  StyleRules,
  Theme,
  createStyles,
  makeStyles,
} from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme: Theme): StyleRules =>
    createStyles({
      albumViewContainerStyle: {
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
      },
      albumViewWrapperStyle: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // justifyContent: 'center',
        width: '100%',
        height: '100%',
      },
      centerContainerStyle: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '30vh',
      },
    })
);

const AlbumView = (): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { pageId, storyId } = useParams();
  const periodData = useSelector((state) => state.app.periodData);

  const [currentImageNr, setCurrentImageNr] = useState(null);

  useEffect(() => {
    dispatch(fetchData(C.PERIOD_DATA, { period: pageId }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const currentPeriodData = periodData[pageId];

  const setImageUrl = (imageNr) => {
    const currentImageData = currentPeriodData?.[imageNr];
    const safeTitle = encodeURI(currentImageData?.content?.title);
    const bid = currentImageData && btoa(safeTitle);

    bid && history.push(`/${pageId}/${bid}`);
  };

  const onImageChange = (imageNr) => {
    setImageUrl(imageNr);
    setCurrentImageNr(imageNr);
  };

  useEffect(() => {
    if (currentPeriodData) {
      if (storyId) {
        const decodedId = atob(storyId);

        const currentNr = currentPeriodData.findIndex(
          (item) => encodeURI(item.content.title) === decodedId
        );

        // const backupNr = currentPeriodData.findIndex(
        //   (item) => item.content.id === decodedId
        // );

        const nr = currentNr;
        const fixedNr = nr < 1 ? 1 : nr;

        // if

        // console.log('>>>>', nr);

        setCurrentImageNr(fixedNr);
      } else {
        onImageChange(1);
      }
    }
  }, [location, currentPeriodData, currentImageNr]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!currentPeriodData || !currentImageNr) {
    return (
      <div className={classes.centerContainerStyle}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className={classes.albumViewContainerStyle}>
      <div className={classes.albumViewWrapperStyle}>
        <ImageStory
          sliderData={currentPeriodData}
          onImageChange={onImageChange}
          currentImageNr={currentImageNr}
        />
      </div>
    </div>
  );
};

export default AlbumView;
